import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-hulpverlening',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconHulpverlening {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="m22.35 16-10.37.02c-2.68.15-4.73 2.26-4.73 4.96V32c.02.55.46 1 1.01 1h1.99v2c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-2h2c.55 0 1-.45 1-1V20.98c.01-2.77-2.13-4.92-4.89-4.98Zm.37 5.86-.24.26-1.51 1.59c-.39.41-1.05.41-1.45 0l-1.51-1.59-.24-.26c-.5-.53-.69-1.32-.37-1.97.53-1.07 1.8-1.21 2.54-.44l.3.32.3-.32c.73-.77 2.01-.62 2.54.44.32.65.13 1.44-.37 1.97ZM10.24 5.53C10.92 2.37 13.76 0 17.16 0c1.99 0 3.79.81 5.07 2.12-.02.72-.2 1.25-.54 1.6-.9.94-3.09.88-5.22.83-2.29-.06-4.64-.11-6.24.98Zm13.47-1.18c.34.82.53 1.71.53 2.65 0 3.87-3.17 7-7.08 7-3.16 0-5.83-2.04-6.74-4.87-.14-.74.06-1.2.42-1.61.93-1.04 3.38-1.03 5.59-.97 2.57.06 5.21.13 6.73-1.46.22-.22.4-.48.55-.75Z"/>
</svg>

    );
  }
}
